import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useUserRoles, type AppRoleName } from '@/lib/roles';

export function StaffRoute({
  children,
  allow,
}: {
  children: React.ReactNode;
  allow: AppRoleName[];
}) {
  const { session, loading: authLoading } = useAuth();
  const { roles, loading } = useUserRoles();

  if (authLoading || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!session) return <Navigate to="/login" replace />;
  const ok =
    roles.includes('system_admin') || allow.some((r) => roles.includes(r));
  if (!ok) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
